import axios from './axios'

export const addAndReturnToRequisition = async (payload) => {
  try {
    const { data } = await axios.post('/gapi/b2b-checkout/product-transfer/cxml', payload, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache'
      },
      withCredentials: true
    })
    return data
  } catch (err) {
    let addAndReturnError = err
    if (err?.response?.data?.message) {
      addAndReturnError = new Error(err.response.data.message)
    }
    console.warn('Failed to add and return to requisition', addAndReturnError)
    throw addAndReturnError
  }
}

export default addAndReturnToRequisition
